// Formats a raw GPU type id for display: split on underscores and uppercase
// each segment, e.g. "rtx_2000_ada" -> "RTX 2000 ADA", "a100_40gb" -> "A100 40GB",
// "l4" -> "L4". The raw id is still used for API calls and option values.
export function formatGpuName(gpuType: string): string {
  if (!gpuType) return gpuType;
  return gpuType
    .split('_')
    .map((part) => part.toUpperCase())
    .join(' ');
}
